import React from 'react';

import {EarlyAccess} from 'presentation/pages/private/early-access';

export const MakeEarlyAccess: React.FC = () => <EarlyAccess />;
